import { getDiscountedPrice } from '@/helpers/productListHelpers/productListGetters'

export const getUpdatedProductListOnLimitChange = (...args) =>
  getUpdatedProductList(getUpdatedProductOnLimitChange, ...args)

export const getUpdatedProductListOnDiscountChange = (...args) =>
  getUpdatedProductList(getUpdatedProductOnDiscountChange, ...args)

export const getUpdatedProductListOnPriceChange = (...args) =>
  getUpdatedProductList(getUpdatedProductOnPriceChange, ...args)

const getUpdatedProductList = (updateFn, productList, productId, ...args) => {
  const productIndex = productList.findIndex(product => product.id === productId)
  const updatedProduct = updateFn(productList[productIndex], ...args)
  return replaceArrItem(productList, updatedProduct, productIndex)
}

//one discount
const getUpdatedProductOnDiscountChange = (product, zoneId, discount) => {
  const fixedPrice = product.fixedPrice || 0
  const hasProductAdditionalKg = product.additionalKilo
  const zoneIndex = product.zoneList.findIndex(zone => zone.id === zoneId)
  const zoneList = replaceArrItem(
    product.zoneList,
    getUpdatedZone(product.zoneList[zoneIndex], discount, hasProductAdditionalKg, fixedPrice),
    zoneIndex,
  )
  return { ...product, zoneList }
}

//all discounts
const getUpdatedProductOnLimitChange = (product, discountRates) => {
  const fixedPrice = product.fixedPrice || 0
  const hasProductAdditionalKg = product.additionalKilo
  const zoneList = product.zoneList.map(zone =>
    getUpdatedZone(zone, discountRates[zone.id], hasProductAdditionalKg, fixedPrice),
  )
  return { ...product, zoneList }
}

const getUpdatedZone = (zone, discount, hasProductAdditionalKg, fixedPrice) => {
  //update amountOutOfDiscount
  const amountOutOfDiscount = discount

  //update basePrices
  const basePrices = getUpdatedBasePricesOnDiscountChange(
    zone.defaultPrices,
    zone.basePrices,
    discount,
    fixedPrice
  )

  if (!hasProductAdditionalKg) {
    return { ...zone, amountOutOfDiscount, basePrices }
  } else {
    //update additionalKgValue
    const additionalKgValue = getDiscountedPrice(zone.defaultAdditionalKgValue, discount)

    return { ...zone, amountOutOfDiscount, basePrices, additionalKgValue }
  }
}

const getUpdatedBasePricesOnDiscountChange = (defaultPrices, basePrices, discount, fixedPrice) =>
  basePrices.map(priceItem => ({
    ...priceItem,
    price: getDiscountedPrice(defaultPrices.find(el => el.id === priceItem.id).price, discount, fixedPrice),
  }))

const replaceArrItem = (arr, item, i) => [...arr.slice(0, i), item, ...arr.slice(i + 1)]

//one price
const getUpdatedProductOnPriceChange = (product, weight, zoneId, price, typeKg) => {
  const zoneIndex = product.zoneList.findIndex(zone => zone.id === zoneId)
  const zoneList = replaceArrItem(
    product.zoneList,
    getPriceUpdatedInZone(product.zoneList[zoneIndex], weight, price, typeKg),
    zoneIndex,
  )
  return { ...product, zoneList }
}

const getPriceUpdatedInZone = (zone, weight, price, typeKg) => {
  if(typeKg === 'kg'){
    const basePrices = zone.basePrices.map(item => (item.id === weight ? { ...item, price } : item))
    return { ...zone, basePrices }
  }
  if(typeKg === 'addKg'){
    const roundedPrice = Number(Number(price).toFixed(2))
    return { ...zone, additionalKgValue: roundedPrice }
  }
}
